import { render } from "./EditPromotions.vue?vue&type=template&id=29529658&scoped=true"
import script from "./EditPromotions.vue?vue&type=script&lang=js"
export * from "./EditPromotions.vue?vue&type=script&lang=js"

import "./EditPromotions.vue?vue&type=style&index=0&id=29529658&scoped=true&lang=scss"

import exportComponent from "C:\\projects\\balkan-app\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29529658"]])

export default __exports__